import React, { Component } from 'react';
import { setActiveResultTab, getSearchResult } from '../../../redux/actions/result.action';
import { connect } from 'react-redux';
import './ResultTab.scss';


class ResultTab extends Component<{ title: string, type: string, imageActive?: any, imageInactive?: any, active: string, toggle: any, searchTerm: string, search: any , onClick: any }, {}> {
    
    componentDidMount() {
        if (this.props.active === this.props.type) {
            if (this.props.active === 'photo') {
                this.props.search(this.props.searchTerm, 'images');
            } else {
                this.props.search(this.props.searchTerm, this.props.active);
            }
        }
    }

    render() {
        return (
            <div className={this.props.type === this.props.active ? "resulttab-white" : "resulttab"} onClick={() => { 
                this.props.onClick();
                this.props.toggle(this.props.type, this.props.searchTerm);
            }}>
                <img src={this.props.type === this.props.active ? this.props.imageActive : this.props.imageInactive} className="resultimage" alt="icon"/>
                <div className="text">{this.props.title}</div>
                <div className={this.props.type === this.props.active ? "gray-border" : "transparent-border"}></div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        active: state.result.active,
        searchTerm: state.result.searchTerm
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        toggle(type: string, term: string) {
            if (type === 'photo') {
                dispatch(getSearchResult(term, 'image'));
            } else if (type === 'text') {
                dispatch(getSearchResult(term, ''));
            } else {
                dispatch(getSearchResult(term, type));
            }
            dispatch(setActiveResultTab(type));
        },
        search(term: string, type: string) {
            dispatch(getSearchResult(term, type));
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResultTab);